import { call, put } from '@redux-saga/core/effects';
import { api, notify, apiErrorHandler } from 'services';
import {
  CreateCompanyWarehouseAccessActions as Actions,
  CreateCompanyWarehouseAccessRequestAction as RequestAction,
} from 'store/ducks/companyWarehouseAccesses';

export function* createCompanyWarehouseAccessRequest(action: any) {
  const { postData, onSuccess, onFailure }: RequestAction = action;
  try {
    yield call(api.post, `company-warehouse-accesses`, postData);
    onSuccess && onSuccess();
    notify('success', 'Restrição de armazém criado com sucesso');
    yield put(Actions.success());
  } catch (error) {
    const { errorMessage, validationErrors } = apiErrorHandler(error);
    onFailure && onFailure();
    notify('error', errorMessage);
    yield put(Actions.failure(errorMessage, validationErrors));
  }
}
